import ajax from "./ajax"

// 地区
export function listArea(params){
    return ajax({
        url:'/api/area/listArea',
        method:'get',
        params
    })
}